import React from "react";
import styled from "styled-components";
import BlockLayout from "../Layout/BlockLayout";
import { sectionPopulationColor } from "./../../Util/Colors";
import {
  Heading1,
  fontSizeMobile,
  lineheightSmall,
  Inter,
  fontSizeTablet,
  lineheightMedium
} from "../../Util/StyleProps";
import { device } from "../../Util/Breakpoints";

const Text = styled.p`
  font-size: ${fontSizeMobile};
  font-family: ${Inter};
  line-height: ${lineheightSmall};
  max-width:600px;

  @media${device.tablet}{
    font-size: ${fontSizeTablet};
    line-height: ${lineheightMedium};
  }
`;

const Wrapper = styled.div`
  height: auto;
  background: ${sectionPopulationColor};
  border-radius: 24px;
`;

const NoMunicipalitySelected = styled.div`
  font-family: ${Inter};
  background: ${sectionPopulationColor};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.15px;
  max-width: 900px;
  margin: auto;
  padding: 64px 32px 48px 32px;
  margin-bottom: 24px;
  @media${device.tablet} {
    padding: 64px 32px 80px 32px;
    margin-bottom: 32px;
  }
`;
const StartPage = props => {
  return (
    <Wrapper>
      <NoMunicipalitySelected>
        <div>
          <Heading1
          >
            Snabb koll på Sveriges kommuner
          </Heading1>
          <Text>
            Hur många bor i kommunen? Hur mycket tjänar de? Och vad används
            marken till? Här får du snabbt svar. Du kan titta på hur det ser ut
            i bara en kommun eller jämföra en kommun med en annan.
          </Text>
          <Text>
            Om du har mobil med geopositioneringen påslagen kan du enkelt få upp
            kommunen du befinner dig i genom att välja ”Din position”.
          </Text>
          <Text>Har du koll på hur det ser ut i din kommun?</Text>
        </div>
      </NoMunicipalitySelected>
    </Wrapper>
  );
};

export default StartPage;
